import Portfolio from "./Screens/Portfolio";

function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;
